import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export default function FAQ({ faqs }) {
    const [expandedFaq, setExpandedFaq] = useState(null);

    return (
        <section id="faq" className="py-20 px-4 bg-gray-50">
            <div className="max-w-3xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-black">
                    Dúvidas <span className="text-cyan-400">Frequentes</span>
                </h2>
                <div className="space-y-3">
                    {faqs.map((faq, idx) => (
                        <div key={idx} className="bg-white rounded-lg shadow-sm border border-gray-200">
                            <button
                                onClick={() => setExpandedFaq(expandedFaq === idx ? null : idx)}
                                className="w-full p-6 text-left flex justify-between items-center hover:bg-gray-50 transition"
                            >
                                <h3 className="font-bold text-lg text-black">{faq.q}</h3>
                                <ChevronDown
                                    size={20}
                                    className={`text-cyan-400 transition ${expandedFaq === idx ? 'rotate-180' : ''}`}
                                />
                            </button>
                            {expandedFaq === idx && (
                                <div className="px-6 pb-6 text-gray-700 border-t border-gray-200">
                                    {faq.a}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
